import { supabase } from "@/integrations/supabase/client";

export interface SupabaseClientService {
  from: typeof supabase.from;
  auth: typeof supabase.auth;
  functions: typeof supabase.functions;
  storage: typeof supabase.storage;
  rpc: (...args: any[]) => Promise<any>;
}

export const supabaseClientService: SupabaseClientService = {
  from: supabase.from.bind(supabase),
  auth: supabase.auth,
  functions: supabase.functions,
  storage: supabase.storage,
  rpc: (...args) => (supabase as any).rpc(...args),
};
